import axios from '../axios'
// 导航栏菜单
export const list = (data) => {
  return axios({
    url: '/api/sys/menu/list',
    method: 'post',
    data
  })
}
// 根据角色查询菜单树（含角色选中状态/权限）
export const roleList = (data) => {
  return axios({
    url: '/api/sys/menu/roleList',
    method: 'post',
    data
  })
}
export const save = (data) => {
  // 增
  if (!data.menuId) {
    return axios({
      url: '/api/sys/menu/saveSysMenu',
      method: 'post',
      data
    })
  } else { // 改
    return axios({
      url: '/api/sys/menu/updateSysMenu',
      method: 'post',
      data
    })
  }
}
// 删除
export const del = (data) => {
  return axios({
    url: '/api/sys/menu/deleteSysMenus',
    method: 'post',
    data
  })
}
export const tree = (data) => {
  return axios({
    url: 'api/menu/tree',
    method: 'post',
    data
  })
}


// WEBPACK FOOTER //
// ./src/api/moudules/menu.js